import { render, staticRenderFns } from "./wali.vue?vue&type=template&id=55a2acca"
import script from "./wali.vue?vue&type=script&lang=js"
export * from "./wali.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a2acca')) {
      api.createRecord('55a2acca', component.options)
    } else {
      api.reload('55a2acca', component.options)
    }
    module.hot.accept("./wali.vue?vue&type=template&id=55a2acca", function () {
      api.rerender('55a2acca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/wali.vue"
export default component.exports